import { reactive } from "@vue/composition-api";
import { apiEndpoint } from "@/configs/api/api-configs";

export function privilegeCodeTemplateModel() {
  const getCodeTemplateList = reactive({
    api: `${apiEndpoint.bcrm_platform}/privilegecodetemplate/List`,
    method: "POST",
    xRequest: "",
    payload: {
      Page: 1,
      Limit: 10,
      Filters: [{ Seq: 1, Key: "query", Value: "" }],
      Ordering: [{ Seq: 1, Key: "seq", Direction: "asc" }],
    },
  });

  const getPrivilegeList = reactive({
    api: `${apiEndpoint.bcrm_platform}/privilegecodetemplate/Privilege_List`,
    method: "POST",
    xRequest: "",
    payload: {
      Page: 1,
      Limit: 10,
      Filters: [{ Seq: 1, Key: "status", Value: "1" }],
      Ordering: [{ Seq: 1, Key: "seq", Direction: "asc" }],
    },
  });

  const getPrivilegeImageList = reactive({
    api: `${apiEndpoint.bcrm_platform}/privilegecodetemplate/PrivilegeImage_List`,
    method: "POST",
    xRequest: "",
    payload: {
      Page: 1,
      Limit: 10,
      Filters: [{ Seq: 1, Key: "", Value: "" }],
      Ordering: [{ Seq: 1, Key: "seq", Direction: "asc" }],
      Privilege_Id: 105,
    },
  });

  const fetchDetailCodeTemplate = reactive({
    api: `${apiEndpoint.bcrm_platform}/privilegecodetemplate/Detail`,
    method: "POST",
    xRequest: "",
    payload: {
      Template_Id: 2,
    },
  });

  const createCodeTemplate = reactive({
    api: `${apiEndpoint.bcrm_platform}/privilegecodetemplate/Create`,
    method: "POST",
    xRequest: "",
    payload: {
      Template_Type: 1,
      Template_Type_Desc: "Template1",
      Status: 1,
      Tracking: true,
      Title: "test_Title",
      Privilege_Id: 105,
      Image_Type: 1,
      ImageId: 0,
      Image_url: null,
      Valid_From: "2022-06-01 00:00:00",
      Valid_Through: "2023-06-01 00:00:00",
      Privilege_Name_Show_Layout: 1,
      Privilege_Name: "test_Privilege_Name",
      Privilege_Name_TextEditor: {
        test_id: 1,
        test_desc: {
          test: "test",
          test_Ref: "AJ1fzwIA9j87Vb2",
        },
      },
      Description_Show_Layout: 1,
      Description: "test_Description",
      Description_TextEditor: {
        test_id: 1,
        test_desc: {
          test: "test",
          test_Ref: "AJ1fzwIA9j87Vb2",
        },
      },
      Condition_Show_Layout: 1,
      Condition_HtmlEditor: "test_Condition_HtmlEditor",
      Condition_TextEditor: {
        fontName: "DBHelvethaicaX",
        fontSize: "20",
        fontStyle: [],
        fontAlign: "center",
        fontColor: "#000000",
        seq: 1,
      },
      Remark_Show_Layout: 1,
      Remark_HtmlEditor: "RemarkRemarkRemarkRemark",
      Remark_TextEditor: {
        fontName: "DBHelvethaicaX",
        fontSize: "20",
        fontStyle: [],
        fontAlign: "center",
        fontColor: "#000000",
        seq: 1,
      },
      Remark_Color_bg: "#304864",
      isExpire: 1,
      Exp_Mode: 1,
      Exp_DT: "2022-06-10 00:00:00",
      Exp_TextEditor: {
        test_id: 1,
        test_desc: {
          test: "test",
          test_Ref: "AJ1fzwIA9j87Vb2",
        },
      },
      Background_Show_Layout: 1,
      Background_Image_Url: "",
      Logo_Show_Layout: 1,
      Logo_Image_Url: "",
      Color_Code: "",
      Color_Icon: "#304864",
    },
  });

  const editCodeTemplate = reactive({
    api: `${apiEndpoint.bcrm_platform}/privilegecodetemplate/Edit`,
    method: "POST",
    xRequest: "",
    payload: {
      Template_Id: 1,
      Status: 1,
      Tracking: true,
      Title: "test_Title",
      Privilege_Id: 105,
      Image_Type: 1,
      ImageId: 0,
      Image_url: null,
      Valid_From: "2022-06-01 00:00:00",
      Valid_Through: "2023-06-01 00:00:00",
      Privilege_Name_Show_Layout: 1,
      Privilege_Name: "test_Privilege_Name",
      Privilege_Name_TextEditor: {
        test_id: 1,
        test_desc: {
          test: "test",
          test_Ref: "AJ1fzwIA9j87Vb2",
        },
      },
      Description_Show_Layout: 1,
      Description: "test_Description",
      Description_TextEditor: {
        test_id: 1,
        test_desc: {
          test: "test",
          test_Ref: "AJ1fzwIA9j87Vb2",
        },
      },
      Condition_Show_Layout: 1,
      Condition_HtmlEditor: "test_Condition_HtmlEditor",
      Condition_TextEditor: {
        fontName: "DBHelvethaicaX",
        fontSize: "18",
        fontStyle: [],
        fontAlign: "left",
        fontColor: "#000000",
        seq: 3,
      },
      Remark_Show_Layout: 1,
      Remark_HtmlEditor: "RemarkRemarkRemarkRemark",
      Remark_TextEditor: {
        fontName: "DBHelvethaicaX",
        fontSize: "20",
        fontStyle: [],
        fontAlign: "center",
        fontColor: "#000000",
        seq: 1,
      },
      isExpire: 1,
      Exp_Mode: 1,
      Exp_DT: "2022-06-10 00:00:00",
      Exp_TextEditor: {
        test_id: 1,
        test_desc: {
          test: "test",
          test_Ref: "AJ1fzwIA9j87Vb2",
        },
      },
      Background_Show_Layout: 1,
      Background_Image_Url: "",
      IsDelete_Background_Image_Url: true,
      Logo_Show_Layout: 0,
      Logo_Image_Url: "",
      IsDelete_Logo_Image_Url: true,
      Color_Code: "",
      Color_Icon: "",
    },
  });

  const deleteCodeTemplate = reactive({
    api: `${apiEndpoint.bcrm_platform}/privilegecodetemplate/Delete`,
    method: "POST",
    xRequest: "",
    payload: {
      Template_Id: 1,
    },
  });

  const getTemplateLink = reactive({
    api: `${apiEndpoint.bcrm_platform}/privilegecodetemplate/CopyLink`,
    method: "POST",
    xRequest: "",
    payload: {
      Template_Id: 1,
    },
  });

  const changeActiveStatus = reactive({
    api: `${apiEndpoint.bcrm_platform}/privilegecodetemplate/ChangeStatus`,
    method: "POST",
    xRequest: "",
    payload: {
      Template_Id: 1,
      Status: 1, //1=Open ,2=Close
    },
  });

  const getInventoryList = reactive({
    api: `${apiEndpoint.bcrm_platform}/privilegecodetemplate/Inventory_List`,
    method: "POST",
    xRequest: "",
    payload: {
      Page: 1,
      Limit: 10,
      Filters: [],
      Ordering: [],
      Privilege_Id: 1,
    },
  });

  const ExportCodeTemplate = reactive({
    api: `${apiEndpoint.bcrm_platform}/privilegecodetemplate/ExportCodeTemplate`,
    method: "POST",
    xRequest: "",
    payload: {
      Template_Id: 1,
      Privilege_Id: 1,
      Entry_Id: 1,
      Export: 0,
      Removal_Stategy: 1,
      Note: "",
    },
  });

  const getExportCodeHistoryList = reactive({
    api: `${apiEndpoint.bcrm_platform}/privilegecodetemplate/ExportCode_History`,
    method: "POST",
    xRequest: "",
    payload: {
      Page: 1,
      Limit: 10,
      Filters: [],
      Ordering: [],
      Template_Id: 1,
    },
  });

  const ImportUpdateCustomer = reactive({
    api: `${apiEndpoint.bcrm_platform}/privilegecodetemplate/ImportUpdateCustomer`,
    method: "POST",
    xRequest: "",
    payload: {
      Import_File: null,
    },
  });

  return {
    getCodeTemplateList,
    getPrivilegeList,
    getPrivilegeImageList,
    fetchDetailCodeTemplate,
    createCodeTemplate,
    editCodeTemplate,
    deleteCodeTemplate,
    getTemplateLink,
    changeActiveStatus,
    getInventoryList,
    ExportCodeTemplate,
    getExportCodeHistoryList,
    ImportUpdateCustomer,
  };
}
